require("./itemDetailsTransactions.less");

class ItemDetailsTransactionsController {
    transactions;
    pageInfo = {pageSize: 100, pageNo: 0};

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
    };

    tableDefinition = {
        settings: {
            promise: null,
            totalElements: null,
            hideToolbar: true,
            onPaginate: (page, limit) => this.changePage(page, limit),
            initialPageSize: 100},
        columns:[
            {title:'Tidspunkt', name: 'createdTime', type:'date', dateFormat: 'dd.MM.yyyy - HH:mm', noOrderBy: true},
            {title:'Lokasjon', name:'locationId', noOrderBy: true},
            {title:'Bruker', name:'createdBy', noOrderBy: true},
            {title:'Type', name:'type', noOrderBy: true},
            {title:'ID', name:'orderNo', noOrderBy: true},
            {title:'Antall', name:'quantity', type:'number', noOrderBy: true}
        ]
    };

    constructor(private toastService, private Items, private $stateParams){
    }

    $onInit() {
        this.getItemTransactions();
    }

    getItemTransactions() {
        this.tableDefinition.settings.promise = this.Items.getItemTransactions({itemId: this.$stateParams.itemId, pageSize: this.pageInfo.pageSize, pageNo: this.pageInfo.pageNo}).$promise.then((results) => {
            this.transactions = results.content;
            this.tableDefinition.settings.totalElements = results.totalElements;
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    changePage(page, limit) {
        this.pageInfo.pageSize = limit;
        this.pageInfo.pageNo = page - 1;
        this.getItemTransactions();
    }
}

class ItemDetailsTransactionsOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcItemDetailsTransactionsController";
    public template: any = require('./itemDetailsTransactions.html');
}

rkcApp.controller("rkcItemDetailsTransactionsController", ['toastService', 'Items', '$stateParams', function(toastService, Items, $stateParams){
    return new ItemDetailsTransactionsController(toastService, Items, $stateParams);
}])
    .component("rkcItemDetailsTransactions", new ItemDetailsTransactionsOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/items/itemDetails/itemDetailsTransactions/itemDetailsTransactions.ts
 **/